import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

// Fetch list of available staff & owner to start a new chat
export const getAvailableUsersPortal = async () => {
  const response = await axiosInstance.get("/chat-portal/users");
  return response.data;
};

// Create a direct or group conversation
export const createConversationPortal = async (data) => {
  const response = await axiosInstance.post("/chat-portal/conversations/create", data);
  return response.data;
};

// Fetch all active conversations for current staff
export const getAllConversationsPortal = async () => {
  const response = await axiosInstance.get("/chat-portal/conversations/all");
  return response.data;
};

// Fetch paginated messages for a given conversation
export const getConversationMessagesPortal = async (conversationId, page = 1, limit = 50) => {
  const queryParams = new URLSearchParams({ page, limit });
  const response = await axiosInstance.get(
    `/chat-portal/conversations/${conversationId}/messages?${queryParams.toString()}`
  );
  return response.data;
};

// Add member to group conversation
export const addGroupMemberPortal = async (conversationId, memberData) => {
  const response = await axiosInstance.post(
    `/chat-portal/conversations/${conversationId}/members`,
    memberData
  );
  return response.data;
};

// Remove member from group conversation
export const removeGroupMemberPortal = async (conversationId, userId) => {
  const response = await axiosInstance.delete(
    `/chat-portal/conversations/${conversationId}/members/${userId}`
  );
  return response.data;
};

// Update group metadata (name, description, groupIcon)
export const updateConversationPortal = async (conversationId, data) => {
  const response = await axiosInstance.put(
    `/chat-portal/conversations/${conversationId}`,
    data
  );
  return response.data;
};

// Soft delete message
export const deleteMessagePortal = async (messageId) => {
  const response = await axiosInstance.delete(`/chat-portal/messages/${messageId}`);
  return response.data;
};

// Upload attachment (image or document) to Cloudinary
export const uploadChatFilePortal = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axiosInstance.post("/chat-portal/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};